
<template>
    <div class="mian-container" id="home-page">
        <dialog-layer v-show="visible">
            <template v-slot:portal>
                <order @close="visible = false" />
            </template>
        </dialog-layer>
        <video id="homeVideo" autoplay playsinline loop muted style="z-index: -1;position: absolute;width: 100%;height: 100%;">
            <source src="https://staticweb.ewan.cn/resources/img/ddj-tw/kv.mp4" type="video/mp4">
        </video>
        <div class="container">
            <div class="logo-hd"></div>
            <div class="main-content" :class="{ online: online }">
                <div class="top-layer">
                    <div class="inner-layer">
                        <!-- 预约下线 -->
                        <div class="contact-inner">
                            <!-- <img class="boy-pic" src="https://staticweb.ewan.cn/resources/img/ddj-tw/boy.png" alt="" /> -->
                            <div class="center-info">
                                <!-- <a href="https://www.facebook.com/happybigboss" target="_blank">
                                    <img class="fb" src="https://staticweb.ewan.cn/resources/img/ddj-tw/fb_top.png" alt="" />
                                </a> -->
                                <div class="left-btn">
                                    <a href="https://www.iyagames.com/ddj-h5/" target="_blank">
                                        <img class="fb" src="@assets/images/play_game.png" alt="" />
                                    </a>
                                    <a href="https://www.facebook.com/happybigboss" target="_blank">
                                        <img class="fb" src="@assets/images/fb_top2.png" alt="" />
                                    </a>
                                </div>

                                <div class="download">
                                    <a href="https://itunes.apple.com/tw/app/id1572988056" target="_blank">
                                        <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/apple.png" alt="" />
                                    </a>
                                    <a href="https://play.google.com/store/apps/details?id=com.lets.psan.hwft"
                                        target="_blank">
                                        <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/google.png" alt="" />
                                    </a>
                                </div>
                                <div class="qrcode">
                                    <img v-if="!m" class="qrcode" src="https://staticweb.ewan.cn/resources/img/ddj-tw/qrcode-google.png" alt="" />
                                    <img v-if="m && android" class="qrcode" src="https://staticweb.ewan.cn/resources/img/ddj-tw/qrcode-google.png"
                                        alt="" />
                                    <img v-if="m && !android" class="qrcode" src="https://staticweb.ewan.cn/resources/img/ddj-tw/qrcode-ios.png"
                                        alt="" />
                                    <img class="light-line" src="https://staticweb.ewan.cn/resources/img/ddj-tw/light-line.png" alt="" />
                                </div>
                            </div>
                            <!-- <img class="girl-pic" src="https://staticweb.ewan.cn/resources/img/ddj-tw/girl.png" alt="" /> -->
                        </div>
                    </div>
                </div>
                <!-- <div class="logo">
          <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/banner_logo.png" alt="" />
        </div> -->
            </div>
        </div>
        <div class="scorll-more">
            <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/more.png" alt="" />
        </div>
        <div class="top-excessive">
            <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/new/top-1.png">
        </div>
        <!-- 浮窗 -->
        <sider-bar v-if="isShowCat" />
        <!-- facebook -->
        <!-- <v-facebook-login
      @sdk-init="sdkInitHandle"
      v-show="false"
      @login="fbLoginHandle"
      app-id="1277616899102578"
    ></v-facebook-login> -->
    </div>
</template>
<script>
import Order from "./Order";
import DialogLayer from "../../components/DialogLayer";
import SiderBar from "../../components/SiderBar";

// import { get_requests } from "@/js/request";

// import VFacebookLogin from "vue-facebook-login-component";

export default {
    data() {
        return {
            FB: null,
            // 预约
            visible: false,
            state: this.$store.state,
            // 上线
            online: false,
            isShowCat: false,
            m: false,
            android: true,
        };
    },
    components: {
        Order,
        DialogLayer,
        SiderBar,
        // VFacebookLogin,
    },
    computed: {
        isLogin: {
            get() {
                return this.state.isLogin;
            },
            set(val) {
                this.state.isLogin = val;
            },
        },
        currentTab: {
            get() {
                return this.state.currentTab;
            },
            set(val) {
                this.state.currentTab = val;
            },
        },
    },
    mounted() {
        this.m = this.isPhone();
        this.android = this.isAndroid();
        window.addEventListener("scroll", this.handleScroll, true);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll, true);
    },
    methods: {
        handleScroll(e) {
            let height =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            let top =
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.pageYOffset;
            this.asycTab(top, height);
            if (top > height) {
                this.isShowCat = true;
            } else {
                this.isShowCat = false;
            }
        },
        asycTab(top, height) {
            const index = Math.floor(top / height);
            switch (index) {
                case 0:
                    this.currentTab = 0;
                    break;
                case 1:
                    this.currentTab = 1;
                    break;
                case 2:
                    this.currentTab = 2;
                    break;
                case 3:
                    this.currentTab = 3;
                    break;
                default:
                    this.currentTab = 0;
            }
        },

        orderHandle() {
            if (this.isLogin) {
                this.visible = true;
            } else {
                this.callLoginFb();
            }
        },
        callLoginFb() {
            try {
                if (!this.FB) {
                    alert("facebook 组件未就绪");
                    return;
                }
                this.FB.getLoginStatus(({ status, authResponse }) => {
                    console.log("status==", status, "authResponse==", authResponse);
                    if (status === "connected") {
                        this.fbLoginHandle({ status, authResponse });
                    } else {
                        this.FB.login(this.fbLoginHandle.bind(this));
                    }
                });
            } catch (e) {
                console.log(e);
            }
        },
        sdkInitHandle({ FB, scope }) {
            this.FB = FB;
            console.log("Facebook ready.");
        },
        /**
         * facebook login callback
         * {
         *	authResponse:
         * accessToken: "EAASJZCF1uF3IBAMJrg6QuurgwYst7GUil4wXzQPPfTLDdhq7InePeym8S7sJ48Jinj1OEnXBGMOTZAVZBFzSw3a7S7ZBKj2JRk4vFleLfxZCYQ6v0af6pjaYNzq9bFZBSPYRft0Wu16ZBZCcO4pLR4hxSG7PZAt496ZAVFva7cKbHEjGnwwL7rungCbzWmdsBPgxUZD"
         * data_access_expiration_time: 1617717179
         * expiresIn: 5183791
         * graphDomain: "facebook"
         * signedRequest: "P4CV0jWMJBL_IrUziAiFAY_BQgVTEk6-Ijn9QJ8oFb4.eyJ1c2VyX2lkIjoiMTA2MjMzODUxNDIzNTg0IiwiY29kZSI6IkFRQjhMNWxpU2NMSUk2TE80WFhVRVR3M1FmdXlQWG9TZ2VpNGdsYkU1VC1HTTVoWTNsU3FlYTcwSkFVMTlDc0UwNXRyWjZLOFRoRVJDYlIwb1dpeG5tc3JqMXJsbXBtbzlQQzdVMlZaQ0dLZ193eWVkTjhCZ3RaVi0tNzFEZGNuOEFHcUpEcXlKY2NxMUVUR2lzc3F1UFFpcGJ4N3d5MHgwbm1DZ0dlSmM2YWRSa3NSU2paUFZaWXhMNW9XNUhycjk0OUNxMVVQb0hCazY0RGFIdmRfZXdpSjk1alBrcF9nenhkTFpJdlZYS3M4UjFuUi1nVW9NTWJEMUo0eS0xOVVEb2ctdk9tX3RnSUtaVk0wZ2dtSnIta184dS1QUVBOckZHSHUtemQzdjl3NmxhSldNcWxfRUc1TXEyeHRwUjFEbnZ6VzlieC0zYnZSQkxCdFN4NDY0cXF0IiwiYWxnb3JpdGhtIjoiSE1BQy1TSEEyNTYiLCJpc3N1ZWRfYXQiOjE2MDk5NDExNzl9"
         * userID: "106233851423584"
         * status: "connected"
         * }
         **/
        fbLoginHandle(data) {
            console.log("data-==", data);
            if (data && data.status === "connected") {
                console.log("===", data);
                let { accessToken, userID: uid } = data.authResponse;
                this.get_requests("/act-login-ddj-yr", "GET", {
                    uid,
                    uname: uid,
                    accessToken,
                })
                    .then(() => {
                        this.isLogin = true;
                        // fb登录成功，直接调用接口
                        //   this.get_requests("/act-service-ddj-yr","GET",{token:accessToken,phone:uid}).then((data)=>{})
                    })
                    .catch((err) => {
                        this.isLogin = false;
                        console.log(JSON.stringify(err));
                    });
            }
        },
        /**
         *  登录:/act-login-ddj-yr?type=3&uid=234123213&uname=昵称&accessToken=FB登录token
            登录后直接返回token，用于收集接口
    
            收集：https://dev-sdk.iyagame.com/act-service-ddj-yr?token=token&phone=34341
            调用后，只管状态码就好了，其它信息不用管
    
            成功的状态码：status = 200
    
            example: 
            // requests 返回的是一个promise对象 用then函数接收
            get_requests("/api/v1/goods", "get", {goodsId: 123}).then((data) => {
                console.log(data)
            });
        * 
        */
        isPhone() {
            var userAgentInfo = navigator.userAgent;
            var Agents = new Array(
                "Android",
                "iPhone",
                "SymbianOS",
                "Windows Phone",
                "iPad",
                "iPod"
            );
            var flag = false;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = true;
                    break;
                }
            }
            return flag;
        },
        isAndroid() {
            var u = navigator.userAgent;
            var ua = u.toLowerCase();
            if (/iphone|ipad|ipod/.test(ua)) {
                return false;
            } else if (/android/.test(ua)) {
            }
            return true;
        },
    },
};
</script>
<style scoped lang="scss" src="./scss/index.scss">
</style>
